import CrowdfundingInvestmentError from './CrowdfundingInvestmentError';

export default CrowdfundingInvestmentError;
